var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("Upload Documents")]),_c('form-component',[_c('form',[(_vm.user && _vm.user.counselor_profile)?_c('uploader'):_vm._e()],1)]),_c('hr'),_c('h5',[_vm._v("Documents")]),_c('document-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }